var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker } from '@emburse/ui-core';
import * as abacusTimeFormatter from '@Shared/helpers/abacusTimeFormatter';
export const DateOfBirthField = (_a) => {
    var { helperText = '', error, slotProps = {} } = _a, rest = __rest(_a, ["helperText", "error", "slotProps"]);
    const { textField = {}, layout = {} } = slotProps, restSlotProps = __rest(slotProps, ["textField", "layout"]);
    return (_jsx(DatePicker, Object.assign({ sx: { width: '100%' }, minDate: abacusTimeFormatter.subtractYears(new Date(), 100), maxDate: abacusTimeFormatter.subtractYears(new Date(), 18), slotProps: Object.assign({ textField: Object.assign({ helperText, color: error ? 'error' : '', size: 'small', focused: error }, textField), layout: Object.assign({ 
                // fix a weird ui bug where the month picker is smaller than the year/ day picker - enforce the same height for all 3 views
                // ie: by default, DatePicker will try to spawn the date dialog at the bottom, however if there isn't enough space, it will spawn at the top
                // the problem is that sometimes the year/ day cannot fit at the bottom but the month can
                // this auto closes the dialog without the user being able to pick the date
                // with the height enforced to be the same, the dialog will always spawn at the same place
                sx: { minHeight: '360px' } }, layout) }, restSlotProps), openTo: "year", views: ['year', 'month', 'day'] }, rest)));
};
